// Play the opening once; scrolling takes over from the frame already reached.
(() => {
  const root = document.querySelector('[data-wl-home]');
  const film = root.querySelector('.film-journey');
  const idle = root.querySelector('.film-idle');
  const portrait = root.querySelector('.portrait');
  const clamp = value => Math.max(0, Math.min(1, value));
  const handoff = .55;
  let mode = 'auto', initialized = false, visible = true, paused = false, reduced = false;
  let progress = 0, anchor = 0, wanted = 0, frame = 0, pending = false, blocked = false;
  let autoAttempted = false, primed = false;
  let returnPivot = 0;
  film.muted = true;
  film.defaultMuted = true;
  film.playsInline = true;
  idle.pause();
  idle.preload = 'none';
  const end = () => Math.max(0, (film.duration || 7.466667) - 1 / 30);
  const notify = () => window.wakeHomeFilm?.();
  function render() {
    if (reduced || film.readyState >= 2) portrait.style.setProperty('--film-mix', reduced ? 0 : 1);
    portrait.dataset.film = film.error ? 'error' : film.readyState >= 2 ? 'ready' : 'loading';
    portrait.dataset.time = film.currentTime.toFixed(2);
    portrait.dataset.mode = reduced ? 'reduced' : mode;
    root.dataset.filmBlocked = String(blocked);
  }
  function schedule() {
    if (!frame && visible && !document.hidden && !reduced) frame = requestAnimationFrame(tick);
  }
  function tick() {
    frame = 0;
    if (!visible || document.hidden || reduced) return;
    const advancing = mode === 'auto';
    if (mode === 'auto') {
      if (film.currentTime >= end() * handoff) {
        film.pause();
        anchor = handoff;
        mode = 'hold';
        wanted = end() * handoff;
      }
    }
    if (mode !== 'auto' && !pending && film.readyState >= 1 && !film.seeking && Math.abs(film.currentTime - wanted) > 1 / 60) film.currentTime = wanted;
    render();
    if (advancing) notify();
    if (mode === 'auto' && !paused && !blocked) schedule();
  }
  function play(fromGesture = false) {
    if (pending || reduced || paused || !visible || document.hidden) return;
    if (!fromGesture && (blocked || (mode === 'auto' ? autoAttempted : primed))) return;
    if (mode === 'hold') return;
    if (mode === 'auto') autoAttempted = true;
    pending = true;
    film.play().then(() => {
      blocked = false;
      primed = true;
      if (mode !== 'auto' || paused || reduced || !visible || document.hidden) film.pause();
    }).catch(error => {
      blocked = error.name !== 'AbortError';
    }).finally(() => {
      pending = false;
      render();
      notify();
      schedule();
    });
  }
  window.resumeHomeFilm = () => {
    if (!blocked || reduced) return false;
    paused = false;
    play(true);
    return true;
  };
  window.updateFilm = (value, isPaused, isReduced, inView = true) => {
    const wasPaused = paused;
    const previousProgress = progress;
    progress = clamp(value);
    visible = inView;
    paused = isPaused;
    reduced = isReduced;
    if (!initialized) {
      initialized = true;
      // A restored scroll position must not replay the opening over the science.
      if (progress > .001 || reduced) mode = 'scroll';
    }
    if ((mode === 'auto' || mode === 'hold') && progress > .001) {
      anchor = mode === 'hold' ? handoff : Math.min(handoff, film.currentTime / end());
      mode = 'scroll';
      film.pause();
    }
    // Preserve the reached frame on takeover, but let the first reverse reach frame zero.
    if (mode === 'scroll' && anchor && !returnPivot && progress < previousProgress) returnPivot = previousProgress;
    if (mode === 'scroll' && returnPivot && progress === 0) { anchor = 0; returnPivot = 0; }
    const scrollFrame = returnPivot && progress < returnPivot
      ? (anchor + (1 - anchor) * returnPivot) * progress / returnPivot
      : anchor + (1 - anchor) * progress;
    const selected = reduced ? 0 : mode === 'auto' ? Math.min(handoff, film.currentTime / end()) : scrollFrame;
    wanted = Math.min(end(), Math.round(selected * end() * 30) / 30);
    if (paused || reduced || !visible || document.hidden) {
      film.pause();
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      if (!reduced && mode !== 'auto') schedule();
    } else {
      if (wasPaused && !blocked) autoAttempted = false;
      play();
      if (mode !== 'auto' || !blocked) schedule();
    }
    render();
    return selected;
  };
  for (const event of ['loadedmetadata', 'loadeddata', 'canplay', 'seeked']) film.addEventListener(event, () => { render(); schedule(); });
  document.addEventListener('touchstart', () => { if (blocked) play(true); }, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      film.pause();
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      if (!reduced && mode !== 'auto') schedule();
    } else {
      autoAttempted = false;
      notify();
    }
  });
})();
